import type { ProgramOption, MerchantOption } from '@shared/types/velocity.types'

// Program and merchant constants shared across features (velocity, billing, etc.)

export const PROGRAM_OPTIONS: ProgramOption[] = [
  { value: "paylink_eu", label: "PayLink EU" },
  { value: "fincore_us", label: "FinCore US" },
  { value: "payworld_pk", label: "PayWorld PK" },
  { value: "merchant_direct", label: "Merchant Direct" },
]

export const MOCK_MERCHANTS: MerchantOption[] = [
  // PayLink EU (10)
  { id: "m-1", name: "Sunrise Coffee Berlin", mid: "MID-100234", program: "paylink_eu", country: "DE" },
  { id: "m-2", name: "Alpine Sports GmbH", mid: "MID-100235", program: "paylink_eu", country: "AT" },
  { id: "m-3", name: "Roma Pizza Express", mid: "MID-100236", program: "paylink_eu", country: "IT" },
  { id: "m-4", name: "Paris Boutique Luxe", mid: "MID-100237", program: "paylink_eu", country: "FR" },
  { id: "m-5", name: "Amsterdam Cycles BV", mid: "MID-100238", program: "paylink_eu", country: "NL" },
  { id: "m-6", name: "Helsinki Tech Store", mid: "MID-100239", program: "paylink_eu", country: "FI" },
  { id: "m-7", name: "Madrid Tapas House", mid: "MID-100240", program: "paylink_eu", country: "ES" },
  { id: "m-8", name: "Lisboa Wine Cellar", mid: "MID-100241", program: "paylink_eu", country: "PT" },
  { id: "m-9", name: "Dublin Pub Co", mid: "MID-100242", program: "paylink_eu", country: "IE" },
  { id: "m-10", name: "Bruxelles Chocolate", mid: "MID-100243", program: "paylink_eu", country: "BE" },
  // FinCore US (6)
  { id: "m-11", name: "NYC Deli Express", mid: "MID-200101", program: "fincore_us", country: "US" },
  { id: "m-12", name: "LA Fitness Hub", mid: "MID-200102", program: "fincore_us", country: "US" },
  { id: "m-13", name: "Chicago Deep Dish", mid: "MID-200103", program: "fincore_us", country: "US" },
  { id: "m-14", name: "Texas BBQ Ranch", mid: "MID-200104", program: "fincore_us", country: "US" },
  { id: "m-15", name: "Miami Beach Resort", mid: "MID-200105", program: "fincore_us", country: "US" },
  { id: "m-16", name: "Seattle Cloud Cafe", mid: "MID-200106", program: "fincore_us", country: "US" },
  // PayWorld PK (4)
  { id: "m-17", name: "Karachi Market Hub", mid: "MID-300201", program: "payworld_pk", country: "PK" },
  { id: "m-18", name: "Lahore Textile Co", mid: "MID-300202", program: "payworld_pk", country: "PK" },
  { id: "m-19", name: "Islamabad Tech Mall", mid: "MID-300203", program: "payworld_pk", country: "PK" },
  { id: "m-20", name: "Peshawar Gems Ltd", mid: "MID-300204", program: "payworld_pk", country: "PK" },
  // Merchant Direct (4)
  { id: "m-21", name: "Sofia Electronics", mid: "MID-400301", program: "merchant_direct", country: "BG" },
  { id: "m-22", name: "Plovdiv Food Market", mid: "MID-400302", program: "merchant_direct", country: "BG" },
  { id: "m-23", name: "Varna Beach Hotel", mid: "MID-400303", program: "merchant_direct", country: "BG" },
  { id: "m-24", name: "Burgas Travel Agency", mid: "MID-400304", program: "merchant_direct", country: "BG" },
]
